import { AUTHORIZATION_HEADER } from '../../../src/authorization';
import { send } from '../../../src/network';
import { type DishTypeV1 } from '../../../src/types/DishTypeV1';
import { type ProductV1 } from '../../../src/types/ProductV1';
import { type CyoDetail } from '../../v2/customers/[id]/cyo/get';

export type CYOProduct = CyoDetail['candidates'][number]['candidates'][number];
type ProductTags = CYOProduct['tags'][number];

export interface ProductWithDishTypes extends ProductV1 {
  dish_types: DishTypeV1[];
}

export interface ProductIncludesAll extends ProductWithDishTypes {
  ingredients: unknown[];
  nutrition_html: string;
  instruction: string;
  remark: string;
  periodicity: number;
  tags: ProductTags[];
}

export interface Params {
  productId: number;
  includes: string;
  customerId?: number;
  orderId?: number;
}

export async function getProduct(params: Params) {
  const { productId, includes, customerId, orderId } = params;
  const query = new URLSearchParams({
    product_id: productId.toString(),
    includes,
  });

  if (customerId !== undefined) {
    query.set('customer_id', customerId.toString());
  }

  if (orderId !== undefined) {
    query.set('order_id', orderId.toString());
  }

  return send<ProductV1 | ProductIncludesAll>({
    method: 'GET',
    path: '/api/get_product/',
    query,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
